type Id = string | number;

/**
 * Company query keys (Server-state rebuild, P4-tail). Preserves today's exact values; the
 * `zefix` member names what used to be an inline `['company', 'zefix', query]` array.
 */
export const companyKeys = {
  root: () => ['company'] as const,
  detail: (id?: Id) => (id ? (['company', String(id)] as const) : (['company'] as const)),
  commercialRegister: (id?: Id) => ['company', 'commercial-register', String(id)] as const,
  zefix: (query: string) => ['company', 'zefix', query] as const,
  legalForms: () => ['company', 'legal-forms'] as const,
} as const;
